import { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight, Calendar } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
// import { Input } from '@/components/ui/input';
import axios from "axios";
import NavBar from "@/components/woost/NavBar";
import { StickyHeader } from "@/components/woost/StickyHeader";

// type BlogPost = {
//   id: number;
//   title: string;
//   excerpt: string;
//   content: string;
//   imageUrl: string;
//   category: string;
//   date: string;
//   author: {
//     name: string;
//     role: string;
//     imageUrl: string;
//   };
//   slug: string;
// };

// Sample blog data
// const blogPosts: BlogPost[] = [
//   {
//     id: 1,
//     title: "7 Ways Nano-Influencers Drive Better ROI Than Celebrities",
//     excerpt:
//       "Learn why smaller creators often deliver better engagement and conversion rates for your campaigns.",
//     content:
//       "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl vel ultricies lacinia, nisl nisl aliquam nisl, et tincidunt nisl nisl sit amet nisl. Sed euismod, nisl vel ultricies lacinia, nisl nisl aliquam nisl, et tincidunt nisl nisl sit amet nisl.",
//     imageUrl:
//       "https://images.unsplash.com/photo-1557804506-669a67965ba0?q=80&w=800",
//     category: "Marketing Strategy",
//     date: "April 10, 2025",
//     author: {
//       name: "Priya Sharma",
//       role: "Marketing Specialist",
//       imageUrl:
//         "https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=200",
//     },
//     slug: "nano-influencers-vs-celebrities",
//   },
//   {
//     id: 2,
//     title: "How to Create a Successful Barter Collaboration Strategy",
//     excerpt:
//       "Everything you need to know about running effective barter campaigns with creators on a limited budget.",
//     content:
//       "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl vel ultricies lacinia, nisl nisl aliquam nisl, et tincidunt nisl nisl sit amet nisl. Sed euismod, nisl vel ultricies lacinia, nisl nisl aliquam nisl, et tincidunt nisl nisl sit amet nisl.",
//     imageUrl:
//       "https://images.unsplash.com/photo-1552581234-26160f608093?q=80&w=800",
//     category: "Barter Campaigns",
//     date: "April 5, 2025",
//     author: {
//       name: "Rahul Verma",
//       role: "Partnerships Lead",
//       imageUrl:
//         "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=200",
//     },
//     slug: "barter-collaboration-strategy",
//   },
//   {
//     id: 3,
//     title: "UGC Content: The Secret Weapon for E-commerce Brands",
//     excerpt:
//       "Discover how user-generated content can dramatically improve your conversion rates and customer trust.",
//     content:
//       "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl vel ultricies lacinia, nisl nisl aliquam nisl, et tincidunt nisl nisl sit amet nisl. Sed euismod, nisl vel ultricies lacinia, nisl nisl aliquam nisl, et tincidunt nisl nisl sit amet nisl.",
//     imageUrl:
//       "https://images.unsplash.com/photo-1563986768609-322da13575f3?q=80&w=800",
//     category: "UGC Strategy",
//     date: "March 28, 2025",
//     author: {
//       name: "Neha Kapoor",
//       role: "Content Strategist",
//       imageUrl:
//         "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=200",
//     },
//     slug: "ugc-content-for-ecommerce",
//   },
//   {
//     id: 4,
//     title: "The Future of Influencer Marketing in India",
//     excerpt:
//       "Key trends and predictions that will shape the creator economy in India over the next 5 years.",
//     content:
//       "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl vel ultricies lacinia, nisl nisl aliquam nisl, et tincidunt nisl nisl sit amet nisl. Sed euismod, nisl vel ultricies lacinia, nisl nisl aliquam nisl, et tincidunt nisl nisl sit amet nisl.",
//     imageUrl:
//       "https://images.unsplash.com/photo-1579389083078-4e7018379f7e?q=80&w=800",
//     category: "Industry Trends",
//     date: "March 22, 2025",
//     author: {
//       name: "Vikram Singh",
//       role: "CEO & Founder",
//       imageUrl:
//         "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=200",
//     },
//     slug: "future-of-influencer-marketing-india",
//   },
//   {
//     id: 5,
//     title: "How to Measure ROI on Your Influencer Campaigns",
//     excerpt:
//       "A comprehensive guide to tracking and measuring the true impact of your influencer marketing efforts.",
//     content:
//       "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl vel ultricies lacinia, nisl nisl aliquam nisl, et tincidunt nisl nisl sit amet nisl. Sed euismod, nisl vel ultricies lacinia, nisl nisl aliquam nisl, et tincidunt nisl nisl sit amet nisl.",
//     imageUrl:
//       "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=800",
//     category: "Analytics",
//     date: "March 15, 2025",
//     author: {
//       name: "Ananya Das",
//       role: "Analytics Lead",
//       imageUrl:
//         "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?q=80&w=200",
//     },
//     slug: "measuring-influencer-campaign-roi",
//   },
//   {
//     id: 6,
//     title: "Creator Economy: Emergence of Nano and Micro Influencers",
//     excerpt:
//       "How small creators with highly engaged audiences are transforming the marketing landscape.",
//     content:
//       "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl vel ultricies lacinia, nisl nisl aliquam nisl, et tincidunt nisl nisl sit amet nisl. Sed euismod, nisl vel ultricies lacinia, nisl nisl aliquam nisl, et tincidunt nisl nisl sit amet nisl.",
//     imageUrl:
//       "https://images.unsplash.com/photo-1598257006458-087169a1f08d?q=80&w=800",
//     category: "Creator Economy",
//     date: "March 8, 2025",
//     author: {
//       name: "Arjun Mehta",
//       role: "Creator Relations",
//       imageUrl:
//         "https://images.unsplash.com/photo-1566492031773-4f4e44671857?q=80&w=200",
//     },
//     slug: "nano-micro-influencers-creator-economy",
//   },
// ];

// Blog categories for filtering
// const categories = Array.from(new Set(blogPosts.map(post => post.category)));

const Blog = (): JSX.Element => {
  // const [searchTerm, setSearchTerm] = useState('');
  // const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [page, setPage] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [filteredPosts, setFilteredPosts] = useState([]);
  // Filter posts based on search term and selected category
  // const filteredPosts = blogPosts.filter(post => {
  //   const matchesSearch = post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //                         post.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
  //   const matchesCategory = selectedCategory ? post.category === selectedCategory : true;
  //   return matchesSearch && matchesCategory;
  // });

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `https://worker.woost.io/blog/wp-json/wp/v2/posts?per_page=${page}&_embed`
        );

        setFilteredPosts(response.data);
      } catch (error) {
        console.error("Error fetching blog posts:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [page]);

  const handleLoadMore = (): void => {
    setPage((prev) => prev + 6);
  };

  const istDate_top = new Date(filteredPosts[0]?.date).toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
  });

  const image_url =
    filteredPosts[0]?._embedded?.["wp:featuredmedia"][0]?.source_url;

  const parser = new DOMParser();
  const title_decoded = parser.parseFromString(
    filteredPosts[0]?.title?.rendered,
    "text/html"
  ).body.textContent;
  const desc_decoded = parser.parseFromString(
    filteredPosts[0]?.excerpt?.rendered,
    "text/html"
  ).body.textContent;


  return (
    <div className="min-h-screen bg-gray-50">
      {/* <div className="bg-woost-black text-white py-6">
        <div className="container mx-auto px-4 md:px-6">
          <div className="flex items-center">
            <Link to="/blog">
              <img
                src="/lovable-uploads/a640d2a4-f462-47db-aaa6-331b0e57fec0.png"
                alt="Woost"
                className="h-10"
              />
            </Link>
          </div>
        </div>
      </div> */}
       <NavBar />
      <StickyHeader />

      <div className="bg-gradient-to-b from-woost-yellow/10 to-transparent py-16 pb-2">
        <div className="container mx-auto px-4 md:px-6">
          <div className="flex flex-col items-center text-center max-w-7xl mx-auto">
            <div className="w-full text-left mt-10">
            <Button variant="outline" className="mb-6" asChild>
              <Link to="/" className="flex items-center gap-2">
                <ArrowLeft size={16} />
                Back to Home
              </Link>
            </Button>
</div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Woost Blog</h1>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 md:px-6 py-12">
        {/* Category filters */}
        {/* <div className="mb-10 flex flex-wrap gap-2 justify-center">
          <Button 
            variant={selectedCategory === null ? "default" : "outline"}
            className={selectedCategory === null ? "bg-woost-yellow text-black hover:bg-woost-yellow/90" : ""}
            onClick={() => setSelectedCategory(null)}
          >
            All Categories
          </Button>
          
          {categories.map(category => (
            <Button 
              key={category} 
              variant={selectedCategory === category ? "default" : "outline"}
              className={selectedCategory === category ? "bg-woost-yellow text-black hover:bg-woost-yellow/90" : ""}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </Button>
          ))}
        </div> */}

        {
         isLoading && <div className="text-4xl text-center">loading...</div>
        }

        {/* Featured post */}
        {filteredPosts.length > 0 && (
          <div className="mb-16">
            <div className="bg-white rounded-2xl overflow-hidden shadow-xl">
              <div className="grid md:grid-cols-2">
                <div className="h-64 md:h-auto relative">
                  <img
                    src={image_url}
                    alt={title_decoded}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-woost-yellow text-black px-3 py-1 rounded-full text-sm font-medium">
                      {filteredPosts[0].status}
                    </span>
                  </div>
                </div>

                <div className="p-6 md:p-8 flex flex-col justify-center">
                  <div className="text-gray-500 flex items-center gap-2 mb-3 uppercase"><Calendar size={16} />{istDate_top}</div>
                  <h2 className="text-2xl md:text-3xl font-bold mb-4">
                    {title_decoded}
                  </h2>
                  <p className="text-gray-600 mb-6">{desc_decoded}</p>

                  <div className="flex items-center gap-4 mb-6">
                    {/* <img 
                      src={filteredPosts[0].author.imageUrl} 
                      alt={filteredPosts[0].author.name} 
                      className="w-12 h-12 rounded-full object-cover"
                    /> */}
                    <div>
                      {/* <p className="font-medium">{filteredPosts[0].author.name}</p>
                      <p className="text-sm text-gray-500">{filteredPosts[0].author.role}</p> */}
                    </div>
                  </div>

                  <Button
                    className="bg-woost-blue hover:bg-woost-blue-dark text-white w-full md:w-auto"
                    asChild
                  >
                    <Link
                      to={`/blog/${filteredPosts[0].slug}`}
                      className="flex items-center justify-center gap-2"
                    >
                      Read Article <ArrowRight size={16} />
                    </Link>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Blog posts grid */}
        {filteredPosts.length > 1 && (
          <>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredPosts.slice(1).map((post, i) => {
                const istDate = new Date(post.date).toLocaleString("en-IN", {
                  timeZone: "Asia/Kolkata",
                });

                const parser = new DOMParser();
                const decoded = parser.parseFromString(
                  post.excerpt.rendered,
                  "text/html"
                ).body.textContent;
                const image_url =
                  post?._embedded?.["wp:featuredmedia"][0]?.source_url;
                return (
                  <div
                    key={i}
                    className="bg-white rounded-xl overflow-hidden shadow-lg group hover:shadow-xl transition-shadow"
                  >
                    <div className="relative h-48 overflow-hidden">
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent z-10"></div>
                      <img
                        src={image_url}
                        alt={post.title.rendered}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                      <div className="absolute bottom-4 left-4 z-20">
                        <span className="bg-woost-yellow text-black text-xs font-medium px-3 py-1 rounded-full">
                          {post.status}
                        </span>
                      </div>
                    </div>

                    <div className="p-6">
                      <div className="text-gray-500 flex items-center gap-2 text-sm mb-2 uppercase">
                      <Calendar size={14} />  {istDate}
                      </div>
                      <h3 className="text-xl font-bold mb-3 group-hover:text-woost-blue transition-colors line-clamp-2">
                        {post.title.rendered}
                      </h3>
                      <p className="text-gray-600 mb-4 line-clamp-3">
                        {decoded}
                      </p>

                      <div className="flex items-center gap-3 mb-4">
                        {/* <img 
                      src={post.author.imageUrl} 
                      alt={post.author.name} 
                      className="w-8 h-8 rounded-full object-cover"
                    /> */}
                        {/* <div className="text-sm">
                      <p className="font-medium">{post.author.name}</p>
                    </div> */}
                      </div>

                      <Link
                        to={`/blog/${post.slug}`}
                        className="inline-flex items-center text-woost-blue font-medium"
                      >
                        Read More <ArrowRight size={16} className="ml-2" />
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Add Load More button */}
            {page > 9 && (
              <div className="flex justify-center mt-12">
                <Button
                  onClick={handleLoadMore}
                  disabled={isLoading}
                  className="bg-woost-blue hover:bg-woost-blue-dark text-white"
                >
                  {isLoading ? "Loading..." : "Load More Posts"}
                </Button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Blog;
